<template>
  <div v-if="alert" class="editor scroll-vertical big-spacer alertlog-details">
    <content-nav-bar>
      <svgicon class="level-item event-icon"
        :name="iconName" width="25" height="25" :original="true">
      </svgicon>
      <i class="level-item small fas fa-arrow-right"></i>
      <p class="block level-item ellipsis title-item">
          {{ name }}
      </p>
    </content-nav-bar>
    <content-nav-bar>Host Info</content-nav-bar>
    <alert-log-host-details :item="alert"></alert-log-host-details>
    <content-nav-bar>{{ alert.parsed.eventType }} Details</content-nav-bar>
    <event-details
      :event="alert.parsed.match.event"
      :related="alert.parsed.related"
      :type="alert.parsed.eventType">
    </event-details>
    <content-nav-bar>Analytic Match Details</content-nav-bar>
    <alert-log-details :item="alert"></alert-log-details>
  </div>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import EventDetails from '@/components/events/EventDetails.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import AlertLogDetails from '@/components/alertlogs/AlertLogDetails.vue';
import AlertLogHostDetails from '@/components/alertlogs/AlertLogHostDetails.vue';

export default {
  name: 'AlertDetails',
  mixins: [alertlog],
  components: {
    EventDetails,
    ContentNavBar,
    AlertLogDetails,
    AlertLogHostDetails,
  },
  props: {
    alert: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      return this.getName(this.alert);
    },
    iconName() {
      return this.getIconName(this.alert);
    },
  },
};
</script>

<style lang="scss" scoped>
.big-spacer {
  padding-bottom: 8rem;
}
</style>
